import { Link } from 'gatsby';
import { ChevronDown, ChevronRight } from 'lucide-react';
import React, { FC, useState } from 'react';
import * as style from './index.module.scss';
import { Node } from '../../tools/Tree';

const Collapsible: FC<{
    pathname: string;
    node: Node<{ path: string; title: string; isOpen: boolean }>;
    onClick?: () => void;
}> = ({ pathname, node, onClick }) => {
    const [isOpen, setIsOpen] = useState(node.isOpen);

    return (
        <>
            <div className={style.primary}>
                <button onClick={() => setIsOpen(!isOpen)} disabled={!node.items}>
                    {isOpen ? <ChevronDown /> : <ChevronRight />}
                </button>
                <Link
                    to={node.path}
                    className={pathname === node.path ? style.focused : ''}
                    onClick={onClick}
                >
                    {node.title}
                </Link>
            </div>
            <div className={style.secondary}>
                {isOpen &&
                    node.items?.map((item) => (
                        <Collapsible
                            key={item.path}
                            pathname={pathname}
                            node={item}
                            onClick={onClick}
                        />
                    ))}
            </div>
        </>
    );
};
export default Collapsible;
